import React, {useRef, useEffect} from 'react'
import './navbar.css';
import firebase from './../../config/fbConfig'
import { Link, withRouter} from 'react-router-dom'

const auth = firebase.auth();
const LiveDB = firebase.database();


function Navbar(props) {
	const menuNav = useRef()
	const wasWrittenInLiveDB = useRef(false)

	useEffect(() => {
		
		if (!props.history.location.pathname.includes("/panel")) {
			auth.signInAnonymously();
		}
		
		auth.onAuthStateChanged(user => {
            if (user) {
				if (user.isAnonymous) {
					let id = user.uid;
					if (!wasWrittenInLiveDB.current) {
						LiveDB.ref('8aEMdD9fd9A7').update({
							[id]: true
						})
					}
					wasWrittenInLiveDB.current = true;
					LiveDB.ref("8aEMdD9fd9A7/" + id).onDisconnect().remove();
				} else { // If not anonymous then just log out
					if (!props.history.location.pathname.includes("/panel")) {
						auth.signOut();
					}
				}
            }
		})
		
	}, [])

	let openCloseMenu = () => {
		if (menuNav.current.checked) {
			document.getElementById('nav').children[1].style.top = (document.getElementById('nav').children[1].getBoundingClientRect().top+200) * -1 + 'px';
		} else {
			document.getElementById('nav').children[1].style.top = '-200px';
		}
	}
	let clickOnLi = () => {
		document.getElementById('nav').children[1].style.top = '-200px';	
		menuNav.current.checked = false;
	}
	if (props.history.location.pathname.includes("/panel")) return null;
	return (
		<div id="nav">


			{!window.location.href.includes('/en') ?

			<React.Fragment>

				<Link to="/" onClick={() => window.scrollTo(0,0)}>
				<img id="itay" src="/assets/navbar/ITAYSWHITE.png" alt="Itay's restaurant"/>
				<img id="icon" src="/assets/navbar/ICON.png" alt="icon fruits"/>
				</Link>

				<ul onClick={clickOnLi} className="hebrew">
					<li style={{display: 'none'}}><Link to="/he">דף הבית</Link></li>
					<Link to='/about' onClick={() => window.scrollTo(0,0)}><li>עלינו</li></Link>
					<Link to="/menu"><li>תפריט & משלוחים</li></Link>
					<Link to="/contact"><li>צור קשר</li></Link>
				</ul>

			</React.Fragment>

			:
			<React.Fragment>
			
			<Link to="/en" onClick={() => window.scrollTo(0,0)}>
			<img id="itay" src="/assets/navbar/ITAYSWHITE.png" alt="Itay's restaurant"/>
			<img id="icon" src="/assets/navbar/ICON.png" alt="icon fruits"/>
			</Link>

			<ul onClick={clickOnLi}>
				<li style={{display: 'none'}}><Link to="/">Home</Link></li>
				<Link to='/en/about' onClick={() => window.scrollTo(0,0)}><li>About</li></Link>
				<Link to="/en/menu"><li>Menu & Delivery</li></Link>
				<Link to="/en/contact"><li>Contact</li></Link>
			</ul>

			</React.Fragment>
			}
			<input type="checkbox" id="toggle-menu" onClick={openCloseMenu} ref={menuNav}/>
				<label htmlFor="toggle-menu">
				<span className="menu-icon"></span>
			</label>

		</div>
	)
}

export default withRouter(Navbar)